export enum PatientSkipStatusType {
  DONT_CHANGE = 'DONT_CHANGE',
  IGNORE = 'IGNORE',
}

export const PatientSkipStatusTypeValues = Object.keys(PatientSkipStatusType);
